"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @private
 */
exports.CARSHARING_ENDPOINTS = {
    getLocations: '/fleet/{{version}}/cities/{{city}}/open-availability-locations',
    getOpenAvailability: '/carsharing/{{version}}/open-availability',
    getAllBookingCost: '/pricing/{{version}}/all-booking-costs',
    getCities: '/fleet/{{version}}/cities',
    getTariffs: '/pricing/{{version}}/tariffs/cities/{{city}}/prices',
    getCityPricing: '/carsharing/{{version}}/{{city}}/vehicles',
    getDailyRates: '/pricing/{{version}}/tariffs/cities/{{city}}/daily-rates',
};
